export default __webpack_public_path__ + "file-asset/859e38d7b7476313b974388aac16c1da-units_sample.csv";